<div>
  <ul class="w-auto nav nav-tabs custom-tabs mx-0">

    <li [class.active]="showRuleForm">
      <a data-toggle="tab" (click)="showRuleForm = true">Geofence Rules</a>
    </li>
    <li [class.active]="!showRuleForm">
      <a data-toggle="tab" (click)="showRuleForm = false">Geofences</a>
    </li>
  </ul>

  @if (!showRuleForm) {
    <div class="content">
      <div class="d-flex align-items-center justify-content-between mb-2">
        <h5 class="text-white fs-5 mb-0">
          Geofences <small>({{geofences.length}})</small>
        </h5>
      </div>
      <!-- Search -->
      <div class="row mb-2">
        <div class="col-lg-10 py-0 incident-search-wrapper">
          <input class="listSearch form-control p-1" type="text" [(ngModel)]="searchQuery" (input)="onSearch($event)"
            placeholder="Search geofences">
          </div>
          <div class="col-lg-2 p-0">
            <button class="btn-sm btn-primary pencil-icon" (click)="startDrawing()">
              <i class="fa fa-pencil"></i>
            </button>
          </div>
        </div>
        <!-- Drawing Form -->
        @if (drawnPolygon) {
          <div class="drawing-form mb-3">
            <div class="form-group">
              <input type="text" [(ngModel)]="newGeofenceLabel" placeholder="Enter geofence name" class="form-control">
              <div class="mt-2">
                <button class="btn btn-primary btn-sm" (click)="saveNewGeofence()" [disabled]="!newGeofenceLabel || !drawnPolygon">
                  Save
                </button>
                <button class="btn btn-secondary btn-sm" (click)="cancelNewGeofence()">
                  Cancel
                </button>
              </div>
            </div>
          </div>
        }
        <!-- Geofence List -->
        <div class="custom-scroll v2">
          <table class="table table-striped table-hover custom-table">
            <tbody>
              @for (geofence of filteredGeofences; track geofence) {
                <tr>
                  <td>
                    <div class="camera-info">
                      <div class="camera-header col-12 d-flex justify-content-between">
                        <span class="camera-name col-8" [title]="geofence.label">
                          {{ geofence.label }}
                        </span>
                        <div class="camera-actions"
                          [ngClass]="showingGeometry(geofence) ? 'visible-item' : 'hidden-item'"
                          (click)="showHideGeometry(geofence)"
                        title="hide/show"></div>
                        <div class="camera-actions">
                          <i class="fa fa-trash" (click)="deleteGeofence(geofence)" title="Delete geofence"></i>
                        </div>
                      </div>
                    </div>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    }
  </div>
  @if (showRuleForm) {
    <div class="content custom-scroll">
      @if (showCreateRuleForm) {
        <div class="content rounded mb-3">
          <div class="d-flex align-items-center justify-content-between mb-2">
            <div class="fs-6 text-white">Create New Rule</div>
            <button class="close-btn text-white fs-4" (click)="showCreateRuleForm = false">×</button>
          </div>
          <form class="rule-form" (ngSubmit)="submitNewRule()">
            <div class="d-flex align-items-center justify-content-between">
              <div class="form-group">
                <input type="text" [(ngModel)]="ruleForm.name" class="form-control geofenceInput w-75" name="name"
                  placeholder="Name" required />
                </div>
                <div class="form-group checkbox-row">
                  <label>
                    <input type="checkbox" [(ngModel)]="ruleForm.ingress" name="ingress" />
                    Ingress
                  </label>
                  <label>
                    <input type="checkbox" [(ngModel)]="ruleForm.egress" name="egress" />
                    Egress
                  </label>
                </div>
              </div>
              <div class="form-group">
                <label>Day of week to apply:</label>
                <div class="checkbox-grid">
                  @for (day of daysOfWeek; track day) {
                    <label>
                      <input type="checkbox"
                        [(ngModel)]="ruleForm.daysOfWeek[day]"
                        [name]="'day_' + day" />
                        {{ day | titlecase }}
                      </label>
                    }
                  </div>
                </div>
                <div class="d-flex justify-content-start gap-4">
                  <div class="form-group">
                    <label class="form-label">Start Hour/Min:</label>
                    <input type="time" [(ngModel)]="ruleForm.startTime" name="startTime" class="form-control" />
                  </div>
                  <div class="form-group">
                    <label class="form-label">End Hour/Min:</label>
                    <input type="time" [(ngModel)]="ruleForm.endTime" name="endTime" class="form-control" />
                  </div>
                </div>
                <!-- <div class="d-flex form-group time-range-row">
                <label>Start Hour/Min:</label>
                <input type="time" [(ngModel)]="ruleForm.startTime" name="startTime" />
              </div>
              <div class="d-flex form-group time-range-row">
                <label>End Hour/Min:</label>
                <input type="time" [(ngModel)]="ruleForm.endTime" name="endTime" />
              </div> -->
              <div class="form-group fs-6">
                <div class="form-group">
                  <div style="margin-top: 10px;">
                    <span style="cursor: default">
                      [@if (!ruleForm['openSelectOrganizations']) {
                      <i (click)="ruleForm['openSelectOrganizations']=true" class="fa fa-plus"></i>
                    }
                    @if (ruleForm['openSelectOrganizations']) {
                      <i (click)="ruleForm['openSelectOrganizations']=false" class="fa fa-minus"></i>
                      }]
                    </span>
                    Select Organizations ({{ getNumberOfSelectedOrgs() }})
                    @if (ruleForm['openSelectOrganizations']) {
                      <span style="float: right">
                        <input type="checkbox" [(ngModel)]="allOrgSelected" (change)="allOrgSelectedChanged()" name="allOrgSelected">
                      </span>
                    }
                  </div>
                  @if (ruleForm['openSelectOrganizations']) {
                    <div class="custom-scroll" style="height: 100px; width: 95%; border: solid 1px #fff;">
                      <table style="background-color: rgba(0,0,0,0)">
                        @for (org of organizations; track org) {
                          <tr>
                            <td>
                              <input type="checkbox"
                                [(ngModel)]="selectedOrgs[org.arcAngelId || org.id]"
                                (change)="orgSelected()"
                                [name]="'org_' + (org.arcAngelId || org.id)">
                                {{ org.name }}
                              </td>
                            </tr>
                          }
                        </table>
                      </div>
                    }
                  </div>
                  <div>
                    [@if (!ruleForm['openSelectUsers']) {
                    <i (click)="ruleForm['openSelectUsers']=true" class="fa fa-plus"></i>
                  }
                  @if (ruleForm['openSelectUsers']) {
                    <i (click)="ruleForm['openSelectUsers']=false" class="fa fa-minus"></i>
                    }]
                    Select Users ({{selectedUsers.length}}):
                  </div>
                  @if (ruleForm['openSelectUsers']) {
                    <div class="custom-scroll" style="height: 100px; width: 95%; border: solid 1px #fff;">
                      <table style="width: 100%; background-color: rgba(0,0,0,0)">
                        <tr>
                          <td style="vertical-align: top">
                            <input type="text"
                              [(ngModel)]="userSearchText"
                              (ngModelChange)="userSearchTextChanged()"
                              style="margin: 3px"
                              placeholder="Search User"
                              name="userSearchText"
                              class="geofenceInput"><br>
                              <div style="width: 100%">
                                <table>
                                  @for (user of filteredUsers; track user) {
                                    <tr>
                                      <td>
                                        {{user.name}}
                                        <button type="button" class="btn-primary" (click)="selectUser(user)" style="float: right">
                                          <i class="fa fa-check"></i>
                                        </button>
                                      </td>
                                    </tr>
                                  }
                                </table>
                              </div>
                            </td>
                            <td style="vertical-align: top; border-left: solid 1px #fff; padding: 5px">
                              <span>Selected Users ({{selectedUsers.length}}):</span>
                              @for (user of selectedUsers; track user) {
                                <div>
                                  {{user.name}}
                                  <i class="fa fa-times" (click)="removeSelectedUser(user)" title="remove"></i>
                                </div>
                              }
                            </td>
                          </tr>
                        </table>
                      </div>
                    }
                    <div style="margin-top: 10px;">
                      [@if (!ruleForm['openSelectGeofences']) {
                      <i (click)="ruleForm['openSelectGeofences']=true" class="fa fa-plus"></i>
                    }
                    @if (ruleForm['openSelectGeofences']) {
                      <i (click)="ruleForm['openSelectGeofences']=false" class="fa fa-minus"></i>
                      }]
                      Select Geofences ({{selectedGeofences.length}}):
                    </div>
                    @if (ruleForm['openSelectGeofences']) {
                      <div class="custom-scroll" style="height: 100px; width: 95%; border: solid 1px #fff;">
                        <table >
                          <tr>
                            <td style=" vertical-align: top">
                              <input type="text"
                                [(ngModel)]="geofenceSearchText"
                                (ngModelChange)="geofenceSearchTextChanged()"
                                style="margin: 3px"
                                placeholder="Search"
                                name="geofenceSearchText"
                                class="geofenceInput"><br>
                                <div style="width: 100%">
                                  <table>
                                    @for (geofence of filteredSelectableGeofences; track geofence) {
                                      <tr>
                                        <td>
                                          {{geofence.label}}
                                          <button type="button" class="btn-primary" (click)="selectGeofence(geofence)" style="float: right">
                                            <i class="fa fa-check"></i>
                                          </button>
                                        </td>
                                      </tr>
                                    }
                                  </table>
                                </div>
                              </td>
                              <td style="vertical-align: top; border-left: solid 1px #fff; padding: 5px">
                                <span>Selected Geofences ({{selectedGeofences.length}}):</span>
                                @for (geofence of selectedGeofences; track geofence) {
                                  <div>
                                    {{geofence.label}}
                                    <i class="fa fa-times" (click)="removeSelectedGeofence(geofence)" title="remove"></i>
                                  </div>
                                }
                              </td>
                            </tr>
                          </table>
                        </div>
                      }
                      <div style="margin-top: 10px;">
                        [@if (!ruleForm.openSelectPerimeters) {
                        <i (click)="ruleForm.openSelectPerimeters=true" class="fa fa-plus"></i>
                      }
                      @if (ruleForm.openSelectPerimeters) {
                        <i (click)="ruleForm.openSelectPerimeters=false" class="fa fa-minus"></i>
                        }]
                        Select Perimeters ({{selectedPerimeters.length}}):
                      </div>
                      @if (ruleForm.openSelectPerimeters) {
                        <div class="custom-scroll" style="height: 100px; width: 95%; border: solid 1px #fff;">
                          <table style="width: 100%; background-color: rgba(0,0,0,0)">
                            <tr>
                              <td >
                                <select class="form-control"
                                  [(ngModel)]="selectedBuilding"
                                  (change)="buildingChanged()"
                                  [ngModelOptions]="{standalone: true}"
                                  [title]="selectedBuilding?.name"
                                  class="geofenceInput w-100">
                                  <option [ngValue]="null">Select Building</option>
                                  @for (building of buildings; track building) {
                                    <option [ngValue]="building">{{building.name}}</option>
                                  }
                                </select>
                              </td>
                              <td style="width: 30%">
                                <select class="form-control"
                                  [(ngModel)]="selectedFloor"
                                  (change)="floorChanged()"
                                  [ngModelOptions]="{standalone: true}"
                                  [title]="selectedFloor?.name"
                                  class="geofenceInput">
                                  <option [ngValue]="null">Select Floor</option>
                                  @for (floor of floors; track floor) {
                                    <option [ngValue]="floor">{{floor.name}}</option>
                                  }
                                </select>
                              </td>
                              <td style="width: 30%">
                                <select class="form-control"
                                  [(ngModel)]="selectedRoom"
                                  (change)="roomChanged()"
                                  [ngModelOptions]="{standalone: true}"
                                  [title]="selectedRoom?.name"
                                  class="geofenceInput">
                                  <option [ngValue]="null">Select Room</option>
                                  @for (room of rooms; track room) {
                                    <option [ngValue]="room">{{room.name}}</option>
                                  }
                                </select>
                              </td>
                            </tr>
                            <tr style="border-bottom: solid 1px #fff">
                              <td colspan="3">
                                @if (filteredPerimeter) {
                                  <span>
                                    {{filteredPerimeter.display}}
                                    @if (!isPerimeterSelected(filteredPerimeter.id)) {
                                      <button
                                        type="button"
                                        class="btn-primary"
                                        (click)="selectFilteredPerimeter()"
                                        title="select">
                                        <i class="fa fa-check"></i>
                                      </button>
                                    }
                                  </span>
                                }
                              </td>
                            </tr>
                            <tr>
                              <td colspan="3">
                                Selected Perimeters ({{selectedPerimeters.length}}):
                                @if (selectedPerimeters.length) {
                                  <span>
                                    <ul>
                                      @for (perimeter of selectedPerimeters; track perimeter) {
                                        <li class="demo-cell-hover">
                                          {{perimeter.display}}
                                          <button type="button"
                                            class="btn-primary"
                                            (click)="removeSelectedPerimeter(perimeter)"
                                            title="remove"
                                            style="float: right">
                                            <i class="fa fa-times" style="float: right"></i>
                                          </button>
                                        </li>
                                      }
                                    </ul>
                                  </span>
                                }
                              </td>
                            </tr>
                          </table>
                        </div>
                      }
                    </div>
                    <div class="form-group fs-6">
                      <label>
                        <input type="checkbox" [(ngModel)]="ruleForm.active" name="active" />
                        Make Active
                      </label>
                    </div>
                    <div class="form-group btn-row">
                      <button type="submit" class="btn-primary">Save</button>
                      <button type="button" class="btn-secondary" (click)="showCreateRuleForm = false">Cancel</button>
                    </div>
                  </form>
                </div>
              }
              <div class="fs-6 text-white">
                List of Existing Rules:
                @if (!showCreateRuleForm) {
                  <button class="btn btn-danger"
                    (click)="showNewRuleForm()"
                    style="float: right; margin-bottom: 3px">
                    Create New
                  </button>
                }
              </div>
              @for (rule of rules; track rule) {
                <div>
                  <table  class="table custom-table mb-1">
                    <tr>
                      <td style="width: 80%">{{rule.name}}</td>
                      <td style="width: 10%">
                        <i class="fa fa-edit text-white bg-transparent" (click)="editRule(rule)"></i>
                      </td>
                      <td style="width: 10%">
                        <i class="fa fa-trash text-white bg-transparent" (click)="deleteRule(rule.id)"></i>
                      </td>
                    </tr>
                  </table>
                  {{rule.localTime}}
                </div>
              }
            </div>
          }
          <!-- <app-geofence-creation-button
          *ngIf="showGeofenceCreator"
          (done)="onGeofenceCreationDone($event)"
          (cancel)="onGeofenceCreationCancel()"
        ></app-geofence-creation-button> -->